// extracted by mini-css-extract-plugin
export default {"section":"Offer_section__Lwjhq","stage":"Offer_stage__jZiZu","title":"Offer_title__0E5LD","text":"Offer_text__YGysA","btnr":"Offer_btnr__NG6Cj"};